// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonComponent_wrapper__QqD0V","pulse":"SkeletonComponent_pulse__u+jEC","shine":"SkeletonComponent_shine__EpSfN"};